module.exports = __webpack_public_path__ + "media/lan/Logo_CAD-3ead047c.png";